import styled from 'styled-components'
import { DatoImage } from '@/elements/global/DatoImage'
import { ImageAndTextBlockRecord } from 'types'
import { TextWithIconBlock } from '@/blocks/TextWithIcon'

type ImageAndTextIconListItemProps = {
  item: ImageAndTextBlockRecord
}
const StyledListCard = styled.div`
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  .list-image {
    flex: 1;
    border-radius: 95px;
    background-color: white;
  }
  .list-text {
    flex: 3;
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    .list-image {
      flex: 1;
    }
    .list-text {
      flex: 4;
    }
  }
`
const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  .text-with-icon {
    margin: 0 0 0 16px;
  }
  .text-with-icon p {
    color: ${(p) => p.theme.v2.onSurface.subduedText};
  }
  h3 {
    margin: 8px 0 0 16px;
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueRegular};
    font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      margin: 8px 0 0 12px;
      font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
    }
  }
  p {
    padding: 0;
    margin: 8px 0 0 16px;
    text-align: left;
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.xxs.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.xxs.lineHeight};

    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      margin: 8px 0 0 12px;
      font-size: ${(p) => p.theme.v2.typography.label.m.fontSize};
      line-height: ${(p) => p.theme.v2.typography.label.m.lineHeight};
    }
  }
`

export const ImageAndTextIconListItem = ({ item }: ImageAndTextIconListItemProps) => {
  const { leftSection, rightSection, id } = item
  const image = leftSection[0].image.responsiveImage
  const title = rightSection[0].title
  const text = rightSection[0].content.blocks[0]
  return (
    <StyledListCard key={id} className="list-item">
      <DatoImage data={image} layout="responsive" className="list-image" />
      <StyledTextContainer className="list-text">
        <h3>{title}</h3>
        <TextWithIconBlock record={text} />
      </StyledTextContainer>
    </StyledListCard>
  )
}
